import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/data" element={<Admin />} />
        <Route path="/admin" element={<Navigate to="/data" replace />} />
      </Routes>
      <Toaster position="top-center" theme="dark" />
    </BrowserRouter>
  );
}

export default App;
